module.exports = __webpack_public_path__ + "img/style_0_2.c7da48d2.png";